// removed by extract-text-webpack-plugin
module.exports = {"root":"_3s2fS","title":"_1IhqU","hoverWrapper":"_UVLcK","hintText":"_23VJR","text":"_35B2K","link":"_npjzL","carouselItem":"_pPgFB","postList":"_H3HvF","listItem":"_2_E8a"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ChannelBar/ChannelBar.scss
// module id = 1126
// module chunks = 2